import React from 'react';

import { Portal } from '@bringg-frontend/bringg-web-infra';

import AllowedEmailDomains from './allowed-email-domains-container';

const SecurityPortal = () => {
	return <Portal element={<AllowedEmailDomains />} nodeId="security-page" />;
};

export default SecurityPortal;
